import { render } from "./DirPickCentro.vue?vue&type=template&id=20cda5fa"
import script from "./DirPickCentro.vue?vue&type=script&lang=ts"
export * from "./DirPickCentro.vue?vue&type=script&lang=ts"
script.render = render

export default script